// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PorterStoreWalletStateApiModel from "../api-model/PorterStoreWalletStateApiModel.bs.js";

function decodeWalletState(data) {
  return {
          wallet_version_id: data.wallet_version_id
        };
}

function execute(json) {
  var data = DeccoUtils$Catalyst.resolveResult(PorterStoreWalletStateApiModel.t_decode(json), "PorterStoreWalletStateEntityMapper.res");
  return {
          wallet_version_id: data.wallet_version_id
        };
}

export {
  decodeWalletState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
